/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import { useSession } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import api from "../../services/api";

export default function QuickResumeCard() {
  const { data: session } = useSession();
  const userId = session?.user?.id;
  
  const [data, setData] = useState<{ lastPlayed: any; latest: any } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) return;
      try {
        const res = await api.get(`/dashboard/resume/${userId}`);
        setData(res.data);
      } catch (err) {
        console.error("Dashboard resume sync failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  if (loading && !data) {
    return (
      <div className="grid grid-cols-1 gap-6 h-full animate-pulse">
        <div className="bg-surface-container-high rounded-2xl h-64" />
      </div>
    );
  }

  // Fallback Mock Data if no results found
  const latest = data?.latest || {
    id: "latest",
    title: "Revenue Operations: The Diamond Workflow",
    module: "Week 4: Advanced Systems",
    publishDate: new Date()
  };

  return (
    <div className="h-full">
      {/* Latest Class Card */}
      <CourseCard 
        course={latest} 
        label="New Release" 
        buttonText="Start Learning" 
        icon="new_releases" 
        extraInfo="Latest available" 
      />
    </div>
  );
}

function CourseCard({ course, label, buttonText, icon, extraInfo }: any) {
  return (
    <div className="bg-gradient-to-br from-emerald-600 to-emerald-800 p-6 md:p-8 rounded-2xl text-white shadow-xl shadow-emerald-900/10 relative overflow-hidden group flex flex-col justify-between transition-all hover:shadow-2xl text-left">
      {/* Abstract Design Elements */}
      <div className="absolute top-0 right-0 w-48 h-48 bg-white/5 rounded-full -mr-24 -mt-24 transition-transform group-hover:scale-110" />
      <div className="absolute bottom-12 right-12 w-12 h-12 bg-emerald-400/20 rounded-lg rotate-12" />

      <div className="relative z-10">
        <div className="flex items-center gap-2 mb-4">
          <span className="text-[10px] font-black bg-white/20 px-2 py-0.5 rounded uppercase tracking-tighter">
            {label}
          </span>
          <span className="text-[10px] font-bold text-emerald-200 uppercase tracking-widest flex items-center gap-1">
            <span className="material-symbols-outlined text-[14px]">{icon}</span>
            {extraInfo}
          </span>
        </div>
        <h3 className="text-xl md:text-2xl font-black leading-tight mb-3 pr-12 tracking-tight line-clamp-2">
          {course.title}
        </h3>
        <p className="text-emerald-100/60 text-xs font-bold uppercase tracking-widest">
          {course.module}
        </p>
      </div>

      <div className="relative z-10 mt-6 md:mt-8">
        <Link to={`/courses/${course.id}`} className="inline-flex items-center gap-3 bg-white text-emerald-900 px-6 py-3 rounded-xl font-black text-[11px] uppercase tracking-widest shadow-lg hover:shadow-xl hover:translate-y-[-2px] active:translate-y-0 transition-all cursor-pointer">
          <span className="material-symbols-outlined fill-1 text-sm">play_circle</span>
          {buttonText}
        </Link>
      </div>
    </div>
  );
}
